import { Button, Text } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import s from "./InstallBanner.module.css";

export interface InstallBannerProps {
  onAccept: () => void;
  onDismiss: () => void;
}

export function InstallBanner({ onAccept, onDismiss }: InstallBannerProps) {
  const { t } = useTranslation("client");

  return (
    <div className={s.root} role="status">
      <Text size="sm" weight="medium">
        {t("install.title", "Asenna Ferrivia puhelimeesi")}
      </Text>
      <div className={s.actions}>
        <Button variant="ghost" onClick={onDismiss}>
          {t("install.dismiss", "Ei nyt")}
        </Button>
        <Button variant="primary" onClick={onAccept}>
          {t("install.accept", "Asenna")}
        </Button>
      </div>
    </div>
  );
}
